/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { SitemapItem } from './SitemapItem'
import {
  SitemapItemFromJSON,
  SitemapItemFromJSONTyped,
  SitemapItemToJSON,
} from './SitemapItem'

/**
 *
 * @export
 * @interface GetSitemap200Response
 */
export interface GetSitemap200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetSitemap200Response
   */
  status: boolean
  /**
   *
   * @type {Array<SitemapItem>}
   * @memberof GetSitemap200Response
   */
  data: Array<SitemapItem>
}

/**
 * Check if a given object implements the GetSitemap200Response interface.
 */
export function instanceOfGetSitemap200Response(
  value: object
): value is GetSitemap200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetSitemap200ResponseFromJSON(
  json: any
): GetSitemap200Response {
  return GetSitemap200ResponseFromJSONTyped(json, false)
}

export function GetSitemap200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetSitemap200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(SitemapItemFromJSON),
  }
}

export function GetSitemap200ResponseToJSON(
  value?: GetSitemap200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(SitemapItemToJSON),
  }
}
